import { z } from 'zod'

export const PaymentMethodSchema = z.object({
  id: z.string(),
  brand: z.string().optional(),
  expiryMonth: z.number().optional(),
  expiryYear: z.number().optional(),
  last4Digits: z.string().optional(),
  default: z.boolean().optional(),
})

export type PaymentMethod = z.infer<typeof PaymentMethodSchema>
